import React, { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import "../ViewAnnouncement/ViewAnnouncement.css"; // Adjust the path as needed

const API_URL = "https://aadyaacademy.org/api"; // Backend API URL

const ViewAnnouncement = ({ announcement, closeForm }) => {
  const [announcementData, setAnnouncementData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAnnouncementData = async () => {
      if (announcement) {
        setAnnouncementData(announcement); // If `announcement` is passed directly
        setLoading(false);
      } else {
        try {
          const response = await axios.get(
            `${API_URL}/announcements/${announcement.id}`
          );
          setAnnouncementData(response.data);
        } catch (err) {
          setError("Error fetching announcement data.");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchAnnouncementData();
  }, [announcement]);

  const formatDate = (dateString) => {
    return moment(dateString).format("DD-MM-YYYY"); // Match Addannouncement format
  };

  if (loading) {
    return (
      <div className="view-container">
        <div className="view">
          <h2>Loading...</h2>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="view-container">
        <div className="view">
          <h2>{error}</h2>
          <div className="view-actions">
            <button className="view-cancel" onClick={closeForm}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="view-container">
      <div className="view">
        <div className="view-header">
          <h2>Announcement Details</h2>
        </div>
        <div className="view-details">
          <div className="announcement-title">
            <div className="field-content">{announcementData.title}</div>
            <strong>Announcement Title:</strong>
          </div>
          <div className="announcement-details">
            <div className="field-content">{announcementData.details}</div>
            <strong>Announcement Details:</strong>
          </div>
          <div className="announcement-category-dates">
            <div className="announcement-category">
              <div className="field-content">{announcementData.category}</div>
              <strong>Category:</strong>
            </div>
            <div className="announcement-from-date">
              <div className="field-content">{formatDate(announcementData.fromDate)}</div>
              <strong>From Date:</strong>
            </div>
            <div className="announcement-to-date">
              <div className="field-content">{formatDate(announcementData.toDate)}</div>
              <strong>To Date:</strong>
            </div>
          </div>
          <div className="announcement-attachment">
            {announcementData.attachmentUrl ? (
              <>
                <div className="field-content">
                  Attachment Available
                </div>
                <p>
                  Existing PDF:{" "}
                  <a
                    href={`${API_URL}/${announcementData.attachmentUrl.replace('https://aadyaacademy.org/', '')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    View PDF
                  </a>
                </p>
              </>
            ) : (
              <div className="field-content">No Attachment</div>
            )}
            <strong>Upload PDF File:</strong>
          </div>
        </div>
        <div className="view-actions">
          <button className="view-close" onClick={closeForm}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewAnnouncement;